import { NextSeo } from 'next-seo';

import { title as defaultSiteTitle } from '@constants';
import { BreadcrumbsData } from '@components';
import { getMetaDescription } from '@helpers';

export type SeoData = {
  metaDesc?: string | null;
  metaRobotsNofollow?: string | null;
  metaRobotsNoindex?: string | null;
  opengraphDescription?: string | null;
  opengraphImage?: { sourceUrl?: string | null } | null;
  opengraphSiteName?: string | null;
  opengraphTitle?: string | null;
  opengraphUrl?: string | null;
  title?: string | null;
  canonical?: string | null;
  breadcrumbs?: BreadcrumbsData | null;
  titlePrefix?: string | null;
};

export const Seo2: React.FC<SeoData> = ({
  metaDesc,
  metaRobotsNofollow,
  metaRobotsNoindex,
  opengraphDescription,
  opengraphImage,
  opengraphSiteName,
  opengraphTitle,
  opengraphUrl,
  title,
  canonical,
  titlePrefix,
}) => (
  <>
    <NextSeo
      canonical={canonical || undefined}
      description={metaDesc || getMetaDescription()}
      title={`${titlePrefix || ''}${
        title || opengraphTitle || defaultSiteTitle
      }`}
      noindex={metaRobotsNoindex === 'noindex'}
      nofollow={metaRobotsNofollow === 'nofollow'}
      openGraph={{
        type: 'website',
        locale: 'ja_JP',
        url: opengraphUrl || canonical || undefined,
        title: opengraphTitle || title || defaultSiteTitle,
        description: opengraphDescription || metaDesc || undefined,
        images: opengraphImage?.sourceUrl
          ? [
              {
                url: opengraphImage.sourceUrl,
                width: 1280,
                height: 720,
              },
            ]
          : undefined,
        /* eslint-disable */
        site_name: opengraphSiteName || undefined,
        /* eslint-enable */
      }}
      twitter={{
        handle: '',
        site: '',
        cardType: 'summary_large_image',
      }}
    />
  </>
);
